// @flow

import * as React from 'react';
import {BodyMono, BodyAltMono} from 'sail/Text';

import {useAccount} from 'docs/data';
import {useStripeClui} from '../helpers/react/provider';

export const TerminalPrompt = () => {
  const {account} = useAccount();
  const isLoggedIn = account?.merchant?.isLoggedIn ?? false;
  const merchantName = account?.merchant?.nickname ?? '';

  let prompt = '$';
  if (isLoggedIn && merchantName.length) {
    prompt = `(${merchantName}) $`;
  }

  return <BodyAltMono style={{color: '#a4cdfe'}}>{prompt}</BodyAltMono>;
};

const StripeCluiTerminalInput = ({paneIdx}: {paneIdx: number}): React.Node => {
  const {
    state: {isFocused, panes, focusedPane},
  } = useStripeClui();

  const {command, cursorIndex, allowInput} = panes[paneIdx];
  const isInputFocused = isFocused && focusedPane === paneIdx;

  if (!allowInput) {
    return <> </>;
  } else {
    return (
      <pre>
        <code>
          <BodyMono
            color="gray200"
            wordBreak="word"
            style={{display: 'inline', whiteSpace: 'pre-wrap'}}
          >
            {<TerminalPrompt />} {command.slice(0, cursorIndex)}
            <pre
              style={{
                backgroundColor: isInputFocused ? '#c1c9d2' : 'transparent',
                border: isInputFocused ? 'none' : '1px solid #c1c9d2',
                color: isInputFocused ? '#2a2f45' : '#c1c9d2',
                display: 'inline',
                whiteSpace: 'pre-wrap',
              }}
            >
              {command.slice(cursorIndex, cursorIndex + 1) || ' '}
            </pre>
            {command.slice(cursorIndex + 1)}
          </BodyMono>
        </code>
      </pre>
    );
  }
};

export default StripeCluiTerminalInput;
